import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const akfLangzeitmiete = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      layout: {
        backText: "Zurück zu akf-mobility.de",
      },
      linkToHome: "https://werkstatt.repareo.de/partner/akf",
    },
  },
};
